export default "__VITE_ASSET__CqTzUlTX__"